<template lang="pug">
.rent-object-features-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="plus" @click="newBookingExtra()") Neues Buchungsextra anlegen
    CopyPasteModal(:id="id" :rentObjectType="rentObjectType" destination="Extras" @copySuccess="reloadData()")

  .card.margin-top
    .main
      b-table(
        :data="rentObjectBookingExtras",
        default-sort-direction="desc",
        default-sort="bookingExtra.price",
        hoverable
      )
        b-table-column(field="bookingExtra.name", label="Name", sortable, v-slot="props")
          | {{ props.row.bookingExtra.name }}

        b-table-column(
          field="interval",
          label="Interval",
          v-slot="props"
        )
          | {{ props.row.bookingExtra.interval === 'once' ? "einmalig" : props.row.bookingExtra.interval === 'daily' ? "pro ÜN" : props.row.bookingExtra.interval }}
        b-table-column(field="bookingExtra.price", label="Preis", sortable, numeric, v-slot="props")
          | {{ props.row.bookingExtra.price/100 | toCurrency }}
        b-table-column(field="bookingExtra.multiplier", label="Multiplikator", v-slot="props")
          | {{ props.row.bookingExtra.multiplier === null ? "-" : props.row.bookingExtra.multiplier }}
        b-table-column(
          field="mandatoryCount",
          label="Pflicht-Menge",
          width="200",
          v-slot="props"
        )
          b-numberinput(
            type="is-light",
            v-model="props.row.mandatoryMinCount",
            min="1",
            :editable="false",
            :disabled="!props.row.mandatoryActive"
            @input="hasUnsavedChanges = true"
          )
        b-table-column(
          field="mandatoryActive",
          label="Pflicht",
          sortable,
          v-slot="props"
        )
          b-checkbox(type="is-success", v-model="props.row.mandatoryActive" @input="hasUnsavedChanges = true")
        b-table-column(
          field="optionalActive",
          label="Optional",
          sortable,
          v-slot="props"
        )
          b-checkbox(type="is-success", v-model="props.row.optionalActive" :disabled="props.row.bookingExtra.onSunday || props.row.bookingExtra.onHoliday" @input="hasUnsavedChanges = true")
        b-table-column(
          label="",
          v-slot="props"
        )
          b-button(icon-right="close", type="is-danger" @click="deleteExtra(props.row)")

  b-modal(
    v-model="isModalActive"
    has-modal-card
    :full-screen="false" 
    :can-cancel="true"
    )
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Ausstattungen bearbeiten
      section.modal-card-body
        b-table(:data="unusedBookingExtras"
                default-sort-direction="asc"
                default-sort="name"
                hoverable)
          b-table-column(field='name' label='Name' sortable, v-slot="props")
            | {{ props.row.name }}
          b-table-column(field='code' label='Code' sortable, v-slot="props")
            b-tag(type="is-light") {{ props.row.code }}
          b-table-column(field='price' label='Preis' sortable, v-slot="props")
            | {{ props.row.price/100 | toCurrency }}
          b-table-column(field='internalDescription' label='Interne Beschreibung' v-slot="props")
            | {{ props.row.internalDescription }}
          b-table-column(field='externalDescription' label='Externe Beschreibung' v-slot="props")
            | {{ props.row.externalDescription }}
          b-table-column(v-slot="props")
            b-button(
                type="is-primary",
                @click="addBookingExtraToRentObject(props.row)"
              ) Hinzufügen

  .button-wrapper.margin-top.right
    .error(v-if="hasUnsavedChanges") Es gibt Änderungen die noch nicht gespeichert wurden.
    b-button(
      type="is-light",
      @click="$router.push({ name: 'DataRentObjects' })"
    ) Abbrechen
    b-button(
      type="is-primary",
      @click="saveRentObjectBookingExtras()"
    ) Speichern

</template>

<script>
import CopyPasteModal from "@/components/molecules/CopyPasteModal.vue";

export default {
  components: {
    CopyPasteModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    rentObjectType: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      hasUnsavedChanges: false,
      checkedRows: [],
      isModalActive: false,
      newBookingExtraId: null,
      rentObjectBookingExtras: [],
    };
  },
  computed: {
    bookingExtras() {
      return this.$store.state.bookingExtras.all;
    },
    unusedBookingExtras() {
      let unusedExtras = [];
      for (let x = 0; x < this.bookingExtras.length; x += 1) {
        let unused = true;
        for (let i = 0; i < this.rentObjectBookingExtras.length; i += 1) {
          if (this.rentObjectBookingExtras[i].bookingExtraId === this.bookingExtras[x].id) {
            unused = false;
            break;
          }
        }
        if (unused) {
          unusedExtras.push(this.bookingExtras[x]);
        }
      }

      return unusedExtras;
    },
  },
  methods: {
    newBookingExtra() {
      this.isModalActive = true;
    },
    addBookingExtraToRentObject(be) {
      this.rentObjectBookingExtras.push({
        bookingExtra: be,
        bookingExtraId: be.id,
        mandatoryMinCount: 1,
        mandatoryActive: true,
        optionalActive: false,
      });
      this.newBookingExtraId = null;
      this.$nextTick(()=>{
        this.saveRentObjectBookingExtras();
      });
      this.isModalActive = false;
    },
    async saveRentObjectBookingExtras() {
      await this.$store.dispatch("rentObjectBookingExtras/create", {
        id: this.id,
        rentObjectBookingExtras: this.rentObjectBookingExtras
      });
      await this.$store.dispatch("rentObjectBookingExtras/findAll", {
        id: this.id,
      });

      this.rentObjectBookingExtras = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectBookingExtras.all)
      );
      this.isModalActive = false;
      this.hasUnsavedChanges = false;
    },
    async reloadData() {
      await this.$store.dispatch("rentObjectBookingExtras/findAll", {
        id: this.id,
      });

      this.rentObjectBookingExtras = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectBookingExtras.all)
      );
      this.hasUnsavedChanges = false;
    },
    async deleteExtra(b) {
      this.$buefy.dialog.confirm({
        title: "Buchungsextra entfernen",
        message: `Sind Sie sicher, dass Sie dieses Buchungsextra <b>${b.bookingExtra.name}</b> entfernen möchten? Sie können jederzeit das Buchunsextra wieder hinzufügen.`,
        confirmText: "Jetzt entfernen",
        cancelText: "Abbrechen",
        type: "is-warning",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectBookingExtras/delete", {
              id: b.id,
            });
            this.reloadData();
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Buchungsextra konnte nicht von diesem Objekt entfernt werden."
            );
          }
        },
      });
    }
  },
  async mounted() {
    await this.$store.dispatch("bookingExtras/findAll");
    await this.$store.dispatch("rentObjectBookingExtras/findAll", {
      id: this.id,
    });

    this.rentObjectBookingExtras = JSON.parse(
      JSON.stringify(this.$store.state.rentObjectBookingExtras.all)
    );
  },
};
</script>

<style lang="scss" scoped>
</style>